"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  return (0, _pick2["default"])(props, ['autoComplete', 'autoFocus', 'checked', 'disabled', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDrop', 'onFocus', 'placeholder', 'type', 'value', 'style', 'maxLength']);
};